/**
 * TanStack Query hooks for `saved-views-shareable-urls`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	savedViewsShareableUrlsQueryKeys,
	type CreateSavedViewsShareableUrlsBody,
	type ListSavedViewsShareableUrlsResponse,
	type SavedViewsShareableUrlsRow,
} from "./api";

export function useSavedViewsShareableUrlsList(): UseQueryResult<ListSavedViewsShareableUrlsResponse, Error> {
	return useQuery({
		queryKey: savedViewsShareableUrlsQueryKeys.list(),
		queryFn: list,
	});
}

export function useSavedViewsShareableUrlsCreate(): UseMutationResult<SavedViewsShareableUrlsRow, Error, CreateSavedViewsShareableUrlsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: savedViewsShareableUrlsQueryKeys.all });
		},
	});
}

export function useSavedViewsShareableUrlsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: savedViewsShareableUrlsQueryKeys.all });
		},
	});
}
